import {MoveDirection} from '../enums';
import {ItemType} from '../types';
import {priority} from '@priority-software/priority-proto-api/lib';

const checkEmptyPlace = (result: ItemType[], selectedItems: ItemType[]) => {
    for (let i = 0; i < result.length; i++) {
        if (!selectedItemsIncludes(selectedItems, result[i])) {
            return true;
        }
    }
    return false;
};

const selectedItemsIncludes = (selectedItems: ItemType[], item: ItemType) => {
    return selectedItems.some(s => s.Title === item.Title);
};

const isMainArea = (item: ItemType | priority.netitems.form.RowViewTabsDesign, index: number) => {
    return index === 0 && (item as priority.netitems.form.RowViewTabsDesign).ColumnsDesign;
};

export const reorderSimpleList = (
    dir: MoveDirection,
    data: ItemType[] | priority.netitems.form.RowViewTabsDesign[],
    selectedItems: ItemType[]
): ItemType[] => {
    const result = [];
    switch (dir) {
        case MoveDirection.TOP:
        case MoveDirection.BOTTOM:
            const moved = [];
            data.forEach((i, index) => {
                // special treatment for mainArea of TabsDesign
                // that doesn't let to move other items higher
                if (
                    selectedItemsIncludes(selectedItems, i) ||
                    (dir === MoveDirection.TOP && isMainArea(i, index))
                ) {
                    moved.push(i);
                } else {
                    result.push(i);
                }
            });
            if (dir === MoveDirection.TOP) {
                moved
                    .slice()
                    .reverse()
                    .forEach(i => {
                        result.unshift(i);
                    });
            } else {
                moved.forEach(i => {
                    result.push(i);
                });
            }
            break;
        case MoveDirection.UP:
            // special treatment for mainArea of TabsDesign
            // that doesn't let to move other items higher
            const _selectedItems = [...selectedItems];
            if (
                data.length &&
                (data[0] as priority.netitems.form.RowViewTabsDesign).ColumnsDesign
            ) {
                _selectedItems.push(data[0]);
            }
            data.forEach((item, index) => {
                if (
                    selectedItemsIncludes(_selectedItems, item) &&
                    checkEmptyPlace(result, _selectedItems)
                ) {
                    result.splice(index - 1, 0, item);
                } else {
                    result.push(item);
                }
            });
            break;
        case MoveDirection.DOWN:
            data.slice()
                .reverse()
                .forEach((item, index) => {
                    if (
                        selectedItemsIncludes(selectedItems, item) &&
                        checkEmptyPlace(result, selectedItems)
                    ) {
                        result.splice(1, 0, item);
                    } else {
                        result.unshift(item);
                    }
                });
            break;
        default:
            break;
    }
    return result;
};
